// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-holder {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #001a4d;
  overflow: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
  transition: width 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}
.sidebar-holder::-webkit-scrollbar {
  display: none;
}
.sidebar-holder.sidebar-expanded {
  width: 230px;
}
.sidebar-holder.sidebar-collapsed {
  width: 61px;
}
.sidebar-holder .sidebar-header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 61px;
  box-sizing: border-box;
  padding: 10px 12px;
  margin: 0;
  background: #001a4d;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.2s ease;
}
.sidebar-holder .sidebar-header:hover {
  background-color: rgba(7, 93, 197, 0.2);
}
.sidebar-holder .sidebar-header:focus-visible {
  outline: 2px solid #075dc5;
  outline-offset: -2px;
}
.sidebar-holder .sidebar-header:active {
  background-color: rgba(7, 93, 197, 0.35);
}
.sidebar-holder .sidebar-header .sidebar-logo-full {
  height: 32px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
  pointer-events: none;
}
.sidebar-holder .sidebar-header .sidebar-logo-icon {
  height: 32px;
  width: 32px;
  object-fit: contain;
  pointer-events: none;
}
.sidebar-holder .sidebar-profile-section {
  flex: 0 0 auto;
  width: 100%;
  box-sizing: border-box;
  padding: 6px 6px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: #001a4d;
}
.sidebar-holder .sidebar-profile-section .sidebar-profile-trigger {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 6px;
  border-radius: 10px;
  cursor: pointer;
  color: #ffffff;
  -webkit-user-select: none;
          user-select: none;
  border: 1px solid transparent;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.sidebar-holder .sidebar-profile-section .sidebar-profile-trigger:hover, .sidebar-holder .sidebar-profile-section .sidebar-profile-trigger:focus-visible {
  background: rgba(7, 93, 197, 0.3);
  border-color: rgba(255, 255, 255, 0.12);
  outline: none;
}
.sidebar-holder .sidebar-profile-section .sidebar-profile-trigger.is-collapsed {
  justify-content: center;
}
.sidebar-holder .sidebar-profile-section .sidebar-profile-avatar {
  flex: 0 0 auto;
  width: 40px !important;
  height: 40px !important;
  line-height: 40px !important;
  background: linear-gradient(135deg, #075dc5 0%, #004195 100%);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  border-radius: 10px !important;
}
.sidebar-holder .sidebar-profile-section .sidebar-profile-avatar.ant-avatar {
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
}
.sidebar-holder .sidebar-profile-section .sidebar-profile-summary {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  min-width: 0;
  flex: 1 1 auto;
}
.sidebar-holder .sidebar-profile-section .sidebar-profile-summary-name {
  display: block;
  overflow: hidden;
  width: 100%;
  margin: 0;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  letter-spacing: 0.01em;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sidebar-holder .sidebar-profile-section .sidebar-profile-summary-id {
  display: block;
  overflow: hidden;
  width: 100%;
  margin: 0;
  color: rgba(255, 255, 255, 0.62);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: 0.02em;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sidebar-holder .sidebar-profile-section .sidebar-profile-trigger-chevron {
  flex-shrink: 0;
  margin-left: 4px;
  color: rgba(255, 255, 255, 0.55);
  font-size: 10px;
}
.sidebar-holder .sidebar-navigation {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  padding-top: 14px;
}
.sidebar-holder .sidebar-navigation::-webkit-scrollbar {
  display: none;
}
.sidebar-holder .sidebar-navigation .ant-menu {
  margin-bottom: 25px;
  background: transparent;
  border-right: none !important;
}
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-submenu-title {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: white !important;
  letter-spacing: 0.01em;
  height: 44px !important;
  line-height: 44px !important;
  margin: 2px 8px !important;
  border-radius: 8px !important;
  padding: 0 12px !important;
  width: calc(100% - 16px) !important;
}
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item a,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item span,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item .ant-menu-title-content,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-submenu-title a,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-submenu-title span,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-submenu-title .ant-menu-title-content {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: inherit !important;
}
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-submenu-title .ant-menu-submenu-arrow {
  color: rgba(255, 255, 255, 0.5) !important;
  right: 12px !important;
}
.sidebar-holder .sidebar-navigation .ant-menu .sidebar-menu-link {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  color: inherit;
  text-decoration: none;
}
.sidebar-holder .sidebar-navigation .ant-menu .sidebar-menu-title {
  display: inline-flex;
  align-items: center;
  width: 100%;
}
.sidebar-holder .sidebar-navigation .ant-menu .sidebar-menu-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-right: 12px;
  flex-shrink: 0;
  color: inherit;
}
.sidebar-holder .sidebar-navigation .ant-menu .sidebar-menu-icon-only {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: inherit;
}
.sidebar-holder .sidebar-navigation .ant-menu .sidebar-menu-icon-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: inherit;
  transition: background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}
.sidebar-holder .sidebar-navigation .ant-menu .sidebar-menu-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1 auto;
}
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item:hover,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-submenu-title:hover {
  background-color: rgba(7, 93, 197, 0.35) !important;
  color: #ffffff !important;
}
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item:hover a,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item:hover span,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item:hover .ant-menu-title-content,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item:hover .sidebar-menu-icon,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-submenu-title:hover a,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-submenu-title:hover span,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-submenu-title:hover .ant-menu-title-content,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-submenu-title:hover .sidebar-menu-icon {
  color: #ffffff !important;
}
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item:hover .sidebar-menu-icon-badge,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-submenu-title:hover .sidebar-menu-icon-badge {
  background-color: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.35);
  color: #ffffff !important;
}
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item:hover .ant-menu-submenu-arrow,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-submenu-title:hover .ant-menu-submenu-arrow {
  color: #ffffff !important;
}
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item-selected,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item-active {
  background-color: rgba(7, 93, 197, 0.55) !important;
  color: #ffffff !important;
}
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item-selected a,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item-selected span,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item-selected .ant-menu-title-content,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item-selected .sidebar-menu-icon,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item-active a,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item-active span,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item-active .ant-menu-title-content,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item-active .sidebar-menu-icon {
  color: #ffffff !important;
  font-weight: 600 !important;
}
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item-selected .sidebar-menu-icon-badge,
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-item-active .sidebar-menu-icon-badge {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.12) inset;
  color: #ffffff !important;
}
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-submenu-open > .ant-menu-submenu-title {
  color: #ffffff !important;
  background-color: rgba(7, 93, 197, 0.45) !important;
}
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-submenu-open > .ant-menu-submenu-title .sidebar-menu-icon {
  color: #ffffff !important;
}
.sidebar-holder .sidebar-navigation .ant-menu .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  color: #ffffff !important;
}
.sidebar-holder .sidebar-navigation .ant-menu-sub.ant-menu-inline {
  background: rgba(0, 0, 0, 0.18) !important;
  padding: 4px 0;
  margin-top: 2px;
  border-radius: 0 0 8px 8px;
  transition: max-height 0.24s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease, transform 0.24s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: top;
}
.sidebar-holder .sidebar-navigation .ant-menu-sub.ant-menu-inline .ant-menu-item {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: white !important;
  height: 40px !important;
  line-height: 40px !important;
  margin: 1px 12px 1px 16px !important;
  border-radius: 6px !important;
  border-radius: 0 !important;
  padding: 0 12px !important;
  width: calc(100% - 28px) !important;
  border-left: 1px solid rgba(255, 255, 255, 0.288);
}
.sidebar-holder .sidebar-navigation .ant-menu-sub.ant-menu-inline .ant-menu-item a,
.sidebar-holder .sidebar-navigation .ant-menu-sub.ant-menu-inline .ant-menu-item span,
.sidebar-holder .sidebar-navigation .ant-menu-sub.ant-menu-inline .ant-menu-item .ant-menu-title-content {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: inherit !important;
}
.sidebar-holder .sidebar-navigation .ant-menu-sub.ant-menu-inline .ant-menu-item .sidebar-menu-icon {
  width: 16px;
  height: 16px;
  margin-right: 10px;
  opacity: 0.85;
}
.sidebar-holder .sidebar-navigation .ant-menu-sub.ant-menu-inline .ant-menu-item:hover {
  background-color: rgba(7, 93, 197, 0.25) !important;
  color: #ffffff !important;
  border-left-color: rgba(7, 93, 197, 0.7);
}
.sidebar-holder .sidebar-navigation .ant-menu-sub.ant-menu-inline .ant-menu-item:hover a,
.sidebar-holder .sidebar-navigation .ant-menu-sub.ant-menu-inline .ant-menu-item:hover span,
.sidebar-holder .sidebar-navigation .ant-menu-sub.ant-menu-inline .ant-menu-item:hover .ant-menu-title-content,
.sidebar-holder .sidebar-navigation .ant-menu-sub.ant-menu-inline .ant-menu-item:hover .sidebar-menu-icon {
  color: #ffffff !important;
}
.sidebar-holder .sidebar-navigation .ant-menu-sub.ant-menu-inline .ant-menu-item-selected {
  background-color: rgba(7, 93, 197, 0.45) !important;
  color: #ffffff !important;
  border-left-color: #075dc5;
}
.sidebar-holder .sidebar-navigation .ant-menu-sub.ant-menu-inline .ant-menu-item-selected a,
.sidebar-holder .sidebar-navigation .ant-menu-sub.ant-menu-inline .ant-menu-item-selected span,
.sidebar-holder .sidebar-navigation .ant-menu-sub.ant-menu-inline .ant-menu-item-selected .ant-menu-title-content,
.sidebar-holder .sidebar-navigation .ant-menu-sub.ant-menu-inline .ant-menu-item-selected .sidebar-menu-icon {
  color: #ffffff !important;
  font-weight: 600 !important;
}
.sidebar-holder .sidebar-navigation .ant-menu-sub.ant-menu-inline .ant-menu-submenu-inline > .ant-menu {
  transition: max-height 0.24s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease, transform 0.24s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: top;
}
.sidebar-holder.sidebar-collapsed .sidebar-navigation.is-collapsed {
  padding-top: 10px;
}
.sidebar-holder.sidebar-collapsed .sidebar-navigation.is-collapsed .ant-menu {
  width: 100% !important;
  min-width: 0 !important;
  background: transparent;
}
.sidebar-holder.sidebar-collapsed .sidebar-navigation.is-collapsed .ant-menu-item,
.sidebar-holder.sidebar-collapsed .sidebar-navigation.is-collapsed .ant-menu-item.sidebar-collapsed-has-children {
  width: 48px !important;
  max-width: 48px !important;
  min-width: 48px !important;
  height: 52px !important;
  line-height: 52px !important;
  padding: 0 !important;
  left: 0 !important;
  right: 0 !important;
  text-indent: 0 !important;
  text-align: center !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 10px !important;
  float: none !important;
  flex-shrink: 0;
  overflow: visible !important;
}
.sidebar-holder.sidebar-collapsed .sidebar-navigation.is-collapsed .ant-menu-item.sidebar-collapsed-has-children {
  position: relative;
}
.sidebar-holder.sidebar-collapsed .sidebar-navigation.is-collapsed .ant-menu-item a,
.sidebar-holder.sidebar-collapsed .sidebar-navigation.is-collapsed .ant-menu-item.sidebar-collapsed-has-children > span {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
  text-indent: 0 !important;
  text-align: center !important;
}
.sidebar-holder.sidebar-collapsed .sidebar-navigation.is-collapsed .ant-menu-title-content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
  text-indent: 0 !important;
  text-overflow: clip !important;
  overflow: visible !important;
}
.sidebar-holder.sidebar-collapsed .sidebar-navigation.is-collapsed .ant-menu-item::after,
.sidebar-holder.sidebar-collapsed .sidebar-navigation.is-collapsed .ant-menu-submenu-title::after,
.sidebar-holder.sidebar-collapsed .sidebar-navigation.is-collapsed .ant-menu-item.sidebar-collapsed-has-children::after {
  display: none !important;
}
.sidebar-holder.sidebar-collapsed .sidebar-navigation.is-collapsed .ant-menu-submenu-arrow {
  display: none !important;
}
.sidebar-holder .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: transparent;
}
.sidebar-holder .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected .btn {
  color: #ededed;
  font-weight: 600;
}
.sidebar-holder .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected .img {
  filter: opacity(1);
}
.sidebar-holder .img {
  filter: opacity(0.5);
}
.sidebar-holder .logout-btn-wrapper {
  flex: 0 0 auto;
  width: 100%;
  box-sizing: border-box;
  background-color: #004195;
}
.sidebar-holder .logout-btn-wrapper .change-password-btn {
  background-color: #004195;
  padding: 10px 21px !important;
  height: auto;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.65);
  border-radius: 0;
  border-bottom: 0.1px solid rgba(88, 88, 88, 0.65);
  border-top: 0.1px solid rgba(88, 88, 88, 0.65);
}
.sidebar-holder .logout-btn-wrapper .change-password-btn:hover, .sidebar-holder .logout-btn-wrapper .change-password-btn:focus {
  color: #ffffff !important;
  background-color: rgba(255, 255, 255, 0.06) !important;
}
.sidebar-holder .logout-btn-wrapper .logout-button {
  padding: 10px 21px !important;
  height: auto;
  line-height: 1.5;
  text-align: left;
  color: rgba(255, 255, 255, 0.65);
  border-radius: 0;
}
.sidebar-holder .logout-btn-wrapper .logout-button:hover, .sidebar-holder .logout-btn-wrapper .logout-button:focus {
  color: #ffffff !important;
  background-color: rgba(255, 255, 255, 0.06) !important;
}
.sidebar-holder .logo-text {
  font-size: 16px;
  font-weight: bold;
  font-family: "Inter", sans-serif;
  font-style: normal;
  line-height: 14px;
  color: #ffffff;
  display: flex;
  align-items: center;
}
.sidebar-holder .logo-text img {
  margin-right: 5px;
}
.sidebar-holder .logo-text .subheading {
  margin-top: 8px;
  font-size: 16px;
  color: #efefef;
}
.sidebar-holder .dropdown-wrapper .dropdown-btn {
  color: #ffffff !important;
  border-radius: 0px !important;
  background: transparent;
  border: none;
  padding: 0 4px;
}
.sidebar-holder .dropdown-wrapper .dropdown-btn span {
  font-size: 16px;
  font-weight: 600;
}
.sidebar-holder .dropdown-wrapper .dropdown-btn:hover, .sidebar-holder .dropdown-wrapper .dropdown-btn:focus {
  border: none;
}
.sidebar-holder .dropdown-wrapper .checkbox-wrapper {
  margin-left: -40px;
  color: #484848;
  padding: 18px;
  margin-top: 10px;
}
.sidebar-holder .dropdown-wrapper .checkbox-wrapper li {
  font-size: 18px;
  font-family: "Inter", sans-serif;
}

.sidebar-tooltip .ant-tooltip-inner {
  background: #ffffff;
  color: #1e293b;
  box-shadow: 0 10px 40px rgba(0, 26, 77, 0.18);
  border-radius: 10px;
  padding: 0;
  min-width: 200px;
  max-width: 280px;
  overflow: visible !important;
}
.sidebar-tooltip .ant-tooltip-arrow-content {
  background-color: #ffffff !important;
}
.sidebar-tooltip .sidebar-tooltip-content {
  padding: 10px 0;
  position: relative;
}
.sidebar-tooltip .sidebar-tooltip-title {
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  padding: 6px 16px 8px;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 4px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}
.sidebar-tooltip .sidebar-tooltip-items {
  display: flex;
  flex-direction: column;
  position: relative;
}
.sidebar-tooltip .sidebar-tooltip-row {
  position: relative;
  width: 100%;
}
.sidebar-tooltip .sidebar-tooltip-row:hover > .sidebar-tooltip-submenu {
  opacity: 1;
  visibility: visible;
  transform: translateX(0);
  pointer-events: auto;
}
.sidebar-tooltip .sidebar-tooltip-item {
  display: flex;
  align-items: center;
  padding: 9px 14px 9px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #334155;
  text-decoration: none;
  transition: background-color 0.15s ease, color 0.15s ease;
  box-sizing: border-box;
  width: 100%;
  min-height: 40px;
  position: relative;
}
.sidebar-tooltip .sidebar-tooltip-item.sidebar-tooltip-item-pseudo {
  -webkit-user-select: none;
          user-select: none;
  cursor: default;
}
.sidebar-tooltip .sidebar-tooltip-item.has-children {
  padding-right: 28px;
}
.sidebar-tooltip .sidebar-tooltip-item:hover, .sidebar-tooltip-row:hover > .sidebar-tooltip .sidebar-tooltip-item {
  background: #eff6ff;
  color: #075dc5;
}
.sidebar-tooltip .sidebar-tooltip-item:hover .sidebar-tooltip-item-icon,
.sidebar-tooltip .sidebar-tooltip-item:hover .sidebar-tooltip-item-caret, .sidebar-tooltip-row:hover > .sidebar-tooltip .sidebar-tooltip-item .sidebar-tooltip-item-icon,
.sidebar-tooltip-row:hover > .sidebar-tooltip .sidebar-tooltip-item .sidebar-tooltip-item-caret {
  color: #075dc5;
}
.sidebar-tooltip .sidebar-tooltip-item:active {
  background: #dbeafe;
}
.sidebar-tooltip .sidebar-tooltip-item-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 17px;
  height: 17px;
  margin-right: 10px;
  color: #64748b;
  flex-shrink: 0;
  transition: color 0.15s ease;
}
.sidebar-tooltip .sidebar-tooltip-item-label {
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sidebar-tooltip .sidebar-tooltip-item-caret {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  width: 14px;
  height: 14px;
  transition: color 0.15s ease;
}
.sidebar-tooltip .sidebar-tooltip-submenu {
  position: absolute;
  left: calc(100% - 4px);
  top: -10px;
  min-width: 210px;
  max-width: 280px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 14px 40px rgba(0, 26, 77, 0.22), 0 4px 14px rgba(15, 23, 42, 0.08);
  padding: 8px 0;
  opacity: 0;
  visibility: hidden;
  transform: translateX(-6px);
  pointer-events: none;
  transition: opacity 0.14s ease, transform 0.14s ease, visibility 0.14s ease;
  z-index: 500;
  display: flex;
  flex-direction: column;
}
.sidebar-tooltip .sidebar-tooltip-submenu::before {
  content: "";
  position: absolute;
  left: -6px;
  top: 0;
  width: 6px;
  height: 100%;
  background: transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/SideBar/styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,oDAAA;EACA,cAAA;AACF;AACE;EACE,aAAA;AACJ;AAEE;EACE,YAAA;AAAJ;AAGE;EACE,WAAA;AADJ;AAIE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,kDAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,sCAAA;AAFJ;AAII;EACE,uCAAA;AAFN;AAKI;EACE,0BAAA;EACA,oBAAA;AAHN;AAMI;EACE,wCAAA;AAJN;AAOI;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;AALN;AAQI;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;AANN;AAUE;EACE,cAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,8CAAA;EACA,mBAAA;AARJ;AAUI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,0DAAA;AARN;AAUM;EAEE,iCAAA;EACA,uCAAA;EACA,aAAA;AATR;AAYM;EACE,uBAAA;AAVR;AAeI;EACE,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,6DAAA;EACA,0CAAA;EACA,yCAAA;EACA,8BAAA;AAbN;AAeM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAbR;AAiBI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;AAfN;AAkBI;EACE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAhBN;AAmBI;EACE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAjBN;AAoBI;EACE,cAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;AAlBN;AAsBE;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,iBAAA;AApBJ;AAsBI;EACE,aAAA;AApBN;AAuBI;EACE,mBAAA;EACA,uBAAA;EACA,6BAAA;AArBN;AAuBM;;EAEE,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,0BAAA;EACA,6BAAA;EACA,0BAAA;EACA,mCAAA;AArBR;AAuBQ;;;;;;EAGE,0BAAA;EACA,2BAAA;EACA,yBAAA;AAlBV;AAuBQ;EACE,0CAAA;EACA,sBAAA;AArBV;AAyBM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;AAvBR;AA0BM;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;AAxBR;AA2BM;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;AAzBR;AA4BM;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA1BR;AA6BM;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,2CAAA;EACA,2CAAA;EACA,cAAA;EACA,uFAAA;AA3BR;AA+BM;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AA7BR;AAgCM;;EAEE,mDAAA;EACA,yBAAA;AA9BR;AAgCQ;;;;;;;;EAIE,yBAAA;AA1BV;AA6BQ;;EACE,2CAAA;EACA,uCAAA;EACA,yBAAA;AA1BV;AA6BQ;;EACE,yBAAA;AA1BV;AA8BM;;EAEE,mDAAA;EACA,yBAAA;AA5BR;AA8BQ;;;;;;;;EAIE,yBAAA;EACA,2BAAA;AAxBV;AA2BQ;;EACE,0CAAA;EACA,sCAAA;EACA,qDAAA;EACA,yBAAA;AAxBV;AA4BM;EACE,yBAAA;EACA,mDAAA;AA1BR;AA4BQ;EACE,yBAAA;AA1BV;AA6BQ;EACE,yBAAA;AA3BV;AAgCI;EACE,0CAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,0HAAA;EAEA,qBAAA;AA/BN;AAiCM;EACE,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,uBAAA;EACA,4BAAA;EACA,oCAAA;EACA,6BAAA;EACA,2BAAA;EACA,0BAAA;EACA,mCAAA;EACA,iDAAA;AA/BR;AAiCQ;;;EAGE,0BAAA;EACA,2BAAA;EACA,yBAAA;AA/BV;AAkCQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AAhCV;AAoCM;EACE,mDAAA;EACA,yBAAA;EACA,wCAAA;AAlCR;AAoCQ;;;;EAIE,yBAAA;AAlCV;AAsCM;EACE,mDAAA;EACA,yBAAA;EACA,0BAAA;AApCR;AAsCQ;;;;EAIE,yBAAA;EACA,2BAAA;AApCV;AAwCM;EACE,0HAAA;EAEA,qBAAA;AAvCR;AA6CI;EACE,iBAAA;AA3CN;AA6CM;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AA3CR;AA8CM;;EAEE,sBAAA;EACA,0BAAA;EACA,0BAAA;EACA,uBAAA;EACA,4BAAA;EACA,qBAAA;EAEA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,8BAAA;EACA,sBAAA;EACA,cAAA;EACA,4BAAA;AA7CR;AAgDM;EACE,kBAAA;AA9CR;AAiDM;;EAEE,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,yBAAA;EACA,6BAAA;AA/CR;AAkDM;EACE,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;AAhDR;AAmDM;;;EAGE,wBAAA;AAjDR;AAoDM;EACE,wBAAA;AAlDR;AAuDE;EACE,6BAAA;AArDJ;AAwDE;EACE,cAAA;EACA,gBAAA;AAtDJ;AAyDE;EACE,kBAAA;AAvDJ;AA0DE;EACE,oBAAA;AAxDJ;AA2DE;EACE,cAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;AAzDJ;AA2DI;EACE,yBAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,iDAAA;EACA,8CAAA;AAzDN;AA2DM;EAEE,yBAAA;EACA,sDAAA;AA1DR;AA8DI;EACE,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;AA5DN;AA8DM;EAEE,yBAAA;EACA,sDAAA;AA7DR;AAkEE;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAhEJ;AAkEI;EACE,iBAAA;AAhEN;AAmEI;EACE,eAAA;EACA,eAAA;EACA,cAAA;AAjEN;AAsEI;EACE,yBAAA;EACA,6BAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;AApEN;AAsEM;EACE,eAAA;EACA,gBAAA;AApER;AAuEM;EAEE,YAAA;AAtER;AA0EI;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;AAxEN;AA0EM;EACE,eAAA;EACA,gCAAA;AAxER;;AA+EE;EACE,mBAAA;EACA,cAAA;EACA,6CAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;AA5EJ;AA+EE;EACE,oCAAA;AA7EJ;AAgFE;EACE,eAAA;EACA,kBAAA;AA9EJ;AAiFE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,gCAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AA/EJ;AAkFE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AAhFJ;AAmFE;EACE,kBAAA;EACA,WAAA;AAjFJ;AAmFI;EACE,UAAA;EACA,mBAAA;EACA,wBAAA;EACA,oBAAA;AAjFN;AAqFE;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,yDAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAnFJ;AAqFI;EACE,yBAAA;UAAA,iBAAA;EACA,eAAA;AAnFN;AAsFI;EACE,mBAAA;AApFN;AAuFI;EAEE,mBAAA;EACA,cAAA;AAtFN;AAwFM;;;EAEE,cAAA;AArFR;AAyFI;EACE,mBAAA;AAvFN;AA2FE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,4BAAA;AAzFJ;AA4FE;EACE,cAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA1FJ;AA6FE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;AA3FJ;AA8FE;EACE,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gFAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;EACA,oBAAA;EACA,2EAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AA5FJ;AA8FI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;AA5FN","sourcesContent":[".sidebar-holder {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  background: #001a4d;\n  overflow: hidden;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  transition: width 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n  flex-shrink: 0;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  &.sidebar-expanded {\n    width: 230px;\n  }\n\n  &.sidebar-collapsed {\n    width: 61px;\n  }\n\n  .sidebar-header {\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 61px;\n    box-sizing: border-box;\n    padding: 10px 12px;\n    margin: 0;\n    background: #001a4d;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.12);\n    cursor: pointer;\n    user-select: none;\n    transition: background-color 0.2s ease;\n\n    &:hover {\n      background-color: rgba(7, 93, 197, 0.2);\n    }\n\n    &:focus-visible {\n      outline: 2px solid #075dc5;\n      outline-offset: -2px;\n    }\n\n    &:active {\n      background-color: rgba(7, 93, 197, 0.35);\n    }\n\n    .sidebar-logo-full {\n      height: 32px;\n      width: auto;\n      max-width: 100%;\n      object-fit: contain;\n      pointer-events: none;\n    }\n\n    .sidebar-logo-icon {\n      height: 32px;\n      width: 32px;\n      object-fit: contain;\n      pointer-events: none;\n    }\n  }\n\n  .sidebar-profile-section {\n    flex: 0 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n    padding: 6px 6px;\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n    background: #001a4d;\n\n    .sidebar-profile-trigger {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      padding: 6px 6px;\n      border-radius: 10px;\n      cursor: pointer;\n      color: #ffffff;\n      user-select: none;\n      border: 1px solid transparent;\n      transition: background 0.15s ease, border-color 0.15s ease;\n\n      &:hover,\n      &:focus-visible {\n        background: rgba(7, 93, 197, 0.3);\n        border-color: rgba(255, 255, 255, 0.12);\n        outline: none;\n      }\n\n      &.is-collapsed {\n        justify-content: center;\n        // padding: 10px;\n      }\n    }\n\n    .sidebar-profile-avatar {\n      flex: 0 0 auto;\n      width: 40px !important;\n      height: 40px !important;\n      line-height: 40px !important;\n      background: linear-gradient(135deg, #075dc5 0%, #004195 100%);\n      border: 1px solid rgba(255, 255, 255, 0.2);\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);\n      border-radius: 10px !important;\n\n      &.ant-avatar {\n        color: #ffffff;\n        font-size: 14px;\n        font-weight: 700;\n      }\n    }\n\n    .sidebar-profile-summary {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 3px;\n      min-width: 0;\n      flex: 1 1 auto;\n    }\n\n    .sidebar-profile-summary-name {\n      display: block;\n      overflow: hidden;\n      width: 100%;\n      margin: 0;\n      color: #ffffff;\n      font-size: 14px;\n      font-weight: 600;\n      line-height: 1.3;\n      letter-spacing: 0.01em;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    .sidebar-profile-summary-id {\n      display: block;\n      overflow: hidden;\n      width: 100%;\n      margin: 0;\n      color: rgba(255, 255, 255, 0.62);\n      font-size: 12px;\n      font-weight: 500;\n      line-height: 1.3;\n      letter-spacing: 0.02em;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    .sidebar-profile-trigger-chevron {\n      flex-shrink: 0;\n      margin-left: 4px;\n      color: rgba(255, 255, 255, 0.55);\n      font-size: 10px;\n    }\n  }\n\n  .sidebar-navigation {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n    padding-top: 14px;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    .ant-menu {\n      margin-bottom: 25px;\n      background: transparent;\n      border-right: none !important;\n\n      .ant-menu-item,\n      .ant-menu-submenu-title {\n        font-size: 14px !important;\n        font-weight: 500 !important;\n        color: white !important;\n        letter-spacing: 0.01em;\n        height: 44px !important;\n        line-height: 44px !important;\n        margin: 2px 8px !important;\n        border-radius: 8px !important;\n        padding: 0 12px !important;\n        width: calc(100% - 16px) !important;\n\n        a,\n        span,\n        .ant-menu-title-content {\n          font-size: 14px !important;\n          font-weight: 500 !important;\n          color: inherit !important;\n        }\n      }\n\n      .ant-menu-submenu-title {\n        .ant-menu-submenu-arrow {\n          color: rgba(255, 255, 255, 0.5) !important;\n          right: 12px !important;\n        }\n      }\n\n      .sidebar-menu-link {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        height: 100%;\n        color: inherit;\n        text-decoration: none;\n      }\n\n      .sidebar-menu-title {\n        display: inline-flex;\n        align-items: center;\n        width: 100%;\n      }\n\n      .sidebar-menu-icon {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        width: 20px;\n        height: 20px;\n        margin-right: 12px;\n        flex-shrink: 0;\n        color: inherit;\n      }\n\n      .sidebar-menu-icon-only {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        height: 100%;\n        color: inherit;\n      }\n\n      .sidebar-menu-icon-badge {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        width: 36px;\n        height: 36px;\n        flex-shrink: 0;\n        border-radius: 8px;\n        background-color: rgba(255, 255, 255, 0.06);\n        border: 1px solid rgba(255, 255, 255, 0.18);\n        color: inherit;\n        transition: background-color 0.18s ease, border-color 0.18s ease,\n          box-shadow 0.18s ease;\n      }\n\n      .sidebar-menu-text {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        flex: 1 1 auto;\n      }\n\n      .ant-menu-item:hover,\n      .ant-menu-submenu-title:hover {\n        background-color: rgba(7, 93, 197, 0.35) !important;\n        color: #ffffff !important;\n\n        a,\n        span,\n        .ant-menu-title-content,\n        .sidebar-menu-icon {\n          color: #ffffff !important;\n        }\n\n        .sidebar-menu-icon-badge {\n          background-color: rgba(255, 255, 255, 0.14);\n          border-color: rgba(255, 255, 255, 0.35);\n          color: #ffffff !important;\n        }\n\n        .ant-menu-submenu-arrow {\n          color: #ffffff !important;\n        }\n      }\n\n      .ant-menu-item-selected,\n      .ant-menu-item-active {\n        background-color: rgba(7, 93, 197, 0.55) !important;\n        color: #ffffff !important;\n\n        a,\n        span,\n        .ant-menu-title-content,\n        .sidebar-menu-icon {\n          color: #ffffff !important;\n          font-weight: 600 !important;\n        }\n\n        .sidebar-menu-icon-badge {\n          background-color: rgba(255, 255, 255, 0.2);\n          border-color: rgba(255, 255, 255, 0.5);\n          box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.12) inset;\n          color: #ffffff !important;\n        }\n      }\n\n      .ant-menu-submenu-open > .ant-menu-submenu-title {\n        color: #ffffff !important;\n        background-color: rgba(7, 93, 197, 0.45) !important;\n\n        .sidebar-menu-icon {\n          color: #ffffff !important;\n        }\n\n        .ant-menu-submenu-arrow {\n          color: #ffffff !important;\n        }\n      }\n    }\n\n    .ant-menu-sub.ant-menu-inline {\n      background: rgba(0, 0, 0, 0.18) !important;\n      padding: 4px 0;\n      margin-top: 2px;\n      border-radius: 0 0 8px 8px;\n      transition: max-height 0.24s cubic-bezier(0.4, 0, 0.2, 1),\n        opacity 0.2s ease, transform 0.24s cubic-bezier(0.4, 0, 0.2, 1);\n      transform-origin: top;\n\n      .ant-menu-item {\n        font-size: 13px !important;\n        font-weight: 500 !important;\n        color: white !important;\n        height: 40px !important;\n        line-height: 40px !important;\n        margin: 1px 12px 1px 16px !important;\n        border-radius: 6px !important;\n        border-radius: 0 !important;\n        padding: 0 12px !important;\n        width: calc(100% - 28px) !important;\n        border-left: 1px solid rgba(255, 255, 255, 0.288);\n\n        a,\n        span,\n        .ant-menu-title-content {\n          font-size: 13px !important;\n          font-weight: 500 !important;\n          color: inherit !important;\n        }\n\n        .sidebar-menu-icon {\n          width: 16px;\n          height: 16px;\n          margin-right: 10px;\n          opacity: 0.85;\n        }\n      }\n\n      .ant-menu-item:hover {\n        background-color: rgba(7, 93, 197, 0.25) !important;\n        color: #ffffff !important;\n        border-left-color: rgba(7, 93, 197, 0.7);\n\n        a,\n        span,\n        .ant-menu-title-content,\n        .sidebar-menu-icon {\n          color: #ffffff !important;\n        }\n      }\n\n      .ant-menu-item-selected {\n        background-color: rgba(7, 93, 197, 0.45) !important;\n        color: #ffffff !important;\n        border-left-color: #075dc5;\n\n        a,\n        span,\n        .ant-menu-title-content,\n        .sidebar-menu-icon {\n          color: #ffffff !important;\n          font-weight: 600 !important;\n        }\n      }\n\n      .ant-menu-submenu-inline > .ant-menu {\n        transition: max-height 0.24s cubic-bezier(0.4, 0, 0.2, 1),\n          opacity 0.2s ease, transform 0.24s cubic-bezier(0.4, 0, 0.2, 1);\n        transform-origin: top;\n      }\n    }\n  }\n\n  &.sidebar-collapsed {\n    .sidebar-navigation.is-collapsed {\n      padding-top: 10px;\n\n      .ant-menu {\n        width: 100% !important;\n        min-width: 0 !important;\n        background: transparent;\n      }\n\n      .ant-menu-item,\n      .ant-menu-item.sidebar-collapsed-has-children {\n        width: 48px !important;\n        max-width: 48px !important;\n        min-width: 48px !important;\n        height: 52px !important;\n        line-height: 52px !important;\n        padding: 0 !important;\n        // margin: 3px auto !important;\n        left: 0 !important;\n        right: 0 !important;\n        text-indent: 0 !important;\n        text-align: center !important;\n        display: flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n        border-radius: 10px !important;\n        float: none !important;\n        flex-shrink: 0;\n        overflow: visible !important;\n      }\n\n      .ant-menu-item.sidebar-collapsed-has-children {\n        position: relative;\n      }\n\n      .ant-menu-item a,\n      .ant-menu-item.sidebar-collapsed-has-children > span {\n        display: flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n        width: 100% !important;\n        height: 100% !important;\n        padding: 0 !important;\n        margin: 0 !important;\n        text-indent: 0 !important;\n        text-align: center !important;\n      }\n\n      .ant-menu-title-content {\n        display: flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n        width: 100% !important;\n        height: 100% !important;\n        padding: 0 !important;\n        margin: 0 !important;\n        text-indent: 0 !important;\n        text-overflow: clip !important;\n        overflow: visible !important;\n      }\n\n      .ant-menu-item::after,\n      .ant-menu-submenu-title::after,\n      .ant-menu-item.sidebar-collapsed-has-children::after {\n        display: none !important;\n      }\n\n      .ant-menu-submenu-arrow {\n        display: none !important;\n      }\n    }\n  }\n\n  .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {\n    background-color: transparent;\n  }\n\n  .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected .btn {\n    color: #ededed;\n    font-weight: 600;\n  }\n\n  .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected .img {\n    filter: opacity(1);\n  }\n\n  .img {\n    filter: opacity(0.5);\n  }\n\n  .logout-btn-wrapper {\n    flex: 0 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n    background-color: #004195;\n\n    .change-password-btn {\n      background-color: #004195;\n      padding: 10px 21px !important;\n      height: auto;\n      line-height: 1.5;\n      color: rgba(255, 255, 255, 0.65);\n      border-radius: 0;\n      border-bottom: 0.1px solid rgba(88, 88, 88, 0.65);\n      border-top: 0.1px solid rgba(88, 88, 88, 0.65);\n\n      &:hover,\n      &:focus {\n        color: #ffffff !important;\n        background-color: rgba(255, 255, 255, 0.06) !important;\n      }\n    }\n\n    .logout-button {\n      padding: 10px 21px !important;\n      height: auto;\n      line-height: 1.5;\n      text-align: left;\n      color: rgba(255, 255, 255, 0.65);\n      border-radius: 0;\n\n      &:hover,\n      &:focus {\n        color: #ffffff !important;\n        background-color: rgba(255, 255, 255, 0.06) !important;\n      }\n    }\n  }\n\n  .logo-text {\n    font-size: 16px;\n    font-weight: bold;\n    font-family: 'Inter', sans-serif;\n    font-style: normal;\n    line-height: 14px;\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n\n    img {\n      margin-right: 5px;\n    }\n\n    .subheading {\n      margin-top: 8px;\n      font-size: 16px;\n      color: #efefef;\n    }\n  }\n\n  .dropdown-wrapper {\n    .dropdown-btn {\n      color: #ffffff !important;\n      border-radius: 0px !important;\n      background: transparent;\n      border: none;\n      padding: 0 4px;\n\n      span {\n        font-size: 16px;\n        font-weight: 600;\n      }\n\n      &:hover,\n      &:focus {\n        border: none;\n      }\n    }\n\n    .checkbox-wrapper {\n      margin-left: -40px;\n      color: #484848;\n      padding: 18px;\n      margin-top: 10px;\n\n      li {\n        font-size: 18px;\n        font-family: 'Inter', sans-serif;\n      }\n    }\n  }\n}\n\n.sidebar-tooltip {\n  .ant-tooltip-inner {\n    background: #ffffff;\n    color: #1e293b;\n    box-shadow: 0 10px 40px rgba(0, 26, 77, 0.18);\n    border-radius: 10px;\n    padding: 0;\n    min-width: 200px;\n    max-width: 280px;\n    overflow: visible !important;\n  }\n\n  .ant-tooltip-arrow-content {\n    background-color: #ffffff !important;\n  }\n\n  .sidebar-tooltip-content {\n    padding: 10px 0;\n    position: relative;\n  }\n\n  .sidebar-tooltip-title {\n    font-size: 13px;\n    font-weight: 600;\n    color: #64748b;\n    padding: 6px 16px 8px;\n    border-bottom: 1px solid #f1f5f9;\n    margin-bottom: 4px;\n    letter-spacing: 0.02em;\n    text-transform: uppercase;\n  }\n\n  .sidebar-tooltip-items {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n  }\n\n  .sidebar-tooltip-row {\n    position: relative;\n    width: 100%;\n\n    &:hover > .sidebar-tooltip-submenu {\n      opacity: 1;\n      visibility: visible;\n      transform: translateX(0);\n      pointer-events: auto;\n    }\n  }\n\n  .sidebar-tooltip-item {\n    display: flex;\n    align-items: center;\n    padding: 9px 14px 9px 16px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #334155;\n    text-decoration: none;\n    transition: background-color 0.15s ease, color 0.15s ease;\n    box-sizing: border-box;\n    width: 100%;\n    min-height: 40px;\n    position: relative;\n\n    &.sidebar-tooltip-item-pseudo {\n      user-select: none;\n      cursor: default;\n    }\n\n    &.has-children {\n      padding-right: 28px;\n    }\n\n    &:hover,\n    .sidebar-tooltip-row:hover > & {\n      background: #eff6ff;\n      color: #075dc5;\n\n      .sidebar-tooltip-item-icon,\n      .sidebar-tooltip-item-caret {\n        color: #075dc5;\n      }\n    }\n\n    &:active {\n      background: #dbeafe;\n    }\n  }\n\n  .sidebar-tooltip-item-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 17px;\n    height: 17px;\n    margin-right: 10px;\n    color: #64748b;\n    flex-shrink: 0;\n    transition: color 0.15s ease;\n  }\n\n  .sidebar-tooltip-item-label {\n    flex: 1 1 auto;\n    min-width: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .sidebar-tooltip-item-caret {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: #94a3b8;\n    width: 14px;\n    height: 14px;\n    transition: color 0.15s ease;\n  }\n\n  .sidebar-tooltip-submenu {\n    position: absolute;\n    left: calc(100% - 4px);\n    top: -10px;\n    min-width: 210px;\n    max-width: 280px;\n    background: #ffffff;\n    border-radius: 10px;\n    box-shadow: 0 14px 40px rgba(0, 26, 77, 0.22), 0 4px 14px rgba(15, 23, 42, 0.08);\n    padding: 8px 0;\n    opacity: 0;\n    visibility: hidden;\n    transform: translateX(-6px);\n    pointer-events: none;\n    transition: opacity 0.14s ease, transform 0.14s ease, visibility 0.14s ease;\n    z-index: 500;\n    display: flex;\n    flex-direction: column;\n\n    &::before {\n      content: '';\n      position: absolute;\n      left: -6px;\n      top: 0;\n      width: 6px;\n      height: 100%;\n      background: transparent;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
